import { memo, ReactNode } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import useTableKeyboardNavigation from "./hooks/useKeyboardNavigation/useTableKeyboardNavigation";

type TableProps = {
  children: ReactNode;
  ariaLabel: string;
  layout?: "auto" | "fixed";
};

const Table = ({ children, ariaLabel, layout = "fixed" }: TableProps) => {
  const props = useTableKeyboardNavigation();

  return (
    <div aria-label={ariaLabel} className={cx(styles.table, styles[layout])} role="grid" {...props}>
      {children}
    </div>
  );
};

Table.displayName = "DS.Table";

export default memo(Table);
